import { Tabs, Tab, Box } from "@mui/material";
import { useState } from "react";
import { useRTL } from "hooks/isRTL";
import SenderInfoTab from "./SenderInfoTab";
import SenderOrdersTab from "./SenderOrdersTab";
import ContactDetailsTab from "./ContactInfoTab"; 

const CustomerDetailsTabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useRTL();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: "100%", marginTop: "2rem", backgroundColor: "white" }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        aria-label="Customer Details Tabs"
        variant="fullWidth"
      >
        <Tab label={t("senderInfo")} />
        <Tab label={t("contactDetails")} />
        <Tab label={t("senderOrders")} />
      </Tabs>

      <Box sx={{ padding: "1rem" }}>
        {activeTab === 0 && <SenderInfoTab />}
        {activeTab === 1 && <ContactDetailsTab />}
        {activeTab === 2 && <SenderOrdersTab />}
      </Box>
    </Box>
  );
};

export default CustomerDetailsTabs;
